'use client';

import type { ProgressProps } from '@radix-ui/themes';

import { Progress } from '@radix-ui/themes';

export { Progress, type ProgressProps };
